import { MapTo } from '@adobe/aem-react-editable-components';
import FeaturedArticle, { FeaturedArticleEditConfig } from './FeaturedArticle';

export default MapTo('cob-corp-acquisition/components/creditonebank/featured-article')(FeaturedArticle, FeaturedArticleEditConfig);